const createErrorRefRegExp = error =>
  new RegExp('(^|\\b|\\s)' + error.get('text').replace(/[$()*+,./?[\\\]^{|}-]/g, '\\$&') + '($|\\b|\\s)', 'gi')
const isDetectableError = (error, text) => 'parse' != error.get('type') || text.toUpperCase() != error.get('text')
const hasParseError = errors => errors.some(error => 'parse' === error.get('type'))

const strategy = {
  errorTypes: ['ref', 'trait', 'parse', 'cluster'],
  detectError: (errors, error, text, callback) => {
    if (!hasParseError(errors) && isDetectableError(error, text) && error.has('text')) {
      if ('cluster' === error.get('type')) {
        const start = error.get('position')
        const end = start + error.get('text').length + 2

        callback(start, end)
      } else {
        const reg = createErrorRefRegExp(error)
        let matchArr
        while ((matchArr = reg.exec(text)) !== null) {
          const start = matchArr.index
          const end = start + matchArr[0].length
          callback(start, end)
        }
      }
    }
  },
  detectErrors: (errors, text, callback) => {
    if (hasParseError(errors)) {
      callback(0, text.length)
    }
  }
}

export default strategy
